export class ReadArticlesManager {
    constructor(currentArticleId, storageKey = "readArticles") {
        this.storageKey = storageKey;
        this.currentArticleId = currentArticleId;
    }
    getReadArticles() {
        const data = localStorage.getItem(this.storageKey);
        return data ? new Set(JSON.parse(data)) : new Set();
    }
    markAsRead(articleId) {
        const readArticles = this.getReadArticles();
        readArticles.add(articleId);
        localStorage.setItem(this.storageKey, JSON.stringify(Array.from(readArticles)));
    }
    isRead(articleId) {
        return this.getReadArticles().has(articleId);
    }
    markCurrentArticleAsRead() {
        if (this.currentArticleId) {
            this.markAsRead(this.currentArticleId);
        }
    }
    updateSeriesArticlesUI(prependIcon = true) {
        document.querySelectorAll(".series-article-list .series-item").forEach((item) => {
            const articleId = item.dataset.articleId;
            if (articleId && this.isRead(articleId)) {
                const targetElement = item.querySelector("h5") || item;
                this.addCheckmarkIcon(targetElement, prependIcon);
            }
        });
    }
    addCheckmarkIcon(item, prependIcon) {
        const checkmarkIcon = document.createElement("i");
        checkmarkIcon.className = "bi bi-check-circle";
        if (item.classList.contains("active")) {
            checkmarkIcon.classList.add("text-light"); // Светлый цвет для синего фона
        }
        else {
            checkmarkIcon.classList.add("text-success"); // Зеленый цвет для обычного фона
        }
        if (prependIcon) {
            checkmarkIcon.classList.add("me-2");
            item.prepend(checkmarkIcon);
        }
        else {
            checkmarkIcon.classList.add("ps-2");
            item.append(checkmarkIcon);
        }
    }
    updateSeriesBottomUI() {
        document.querySelectorAll(".series-info-bottom .list-unstyled a").forEach((item) => {
            const articleId = item.dataset.articleId;
            if (articleId && this.isRead(articleId)) {
                this.addCheckmarkIcon(item, false);
            }
        });
    }
}
